import React, { useState } from "react";
import UniversalDataGrid from "../../components/DataGrid";
import WorkOrderModal from "./WorkOrderModal";
import {Box, Typography} from "@mui/material";
import {GetWorkOrderLines} from "../../utils/AxiosUtils";
import {SiteContext} from "../../utils/SiteContext";

export default function WorkOrdersPage() {
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowDetail, setRowDetail] = useState([]);
  const orderPage = {page: 1, pg_size: 500, count: 0};
  const {userInfo} = React.useContext(SiteContext);
  const [user] = userInfo;

  const handleRowClick = (params) => {
    setSelectedRow(params.row);
    GetWorkOrderLines(params.row.work_order, setRowDetail, orderPage);
  };

  const handleCloseModal = () => {
    setSelectedRow(null);
  };

  const columns = [
    ...(user.staff ? [{ field: 'cust', headerName: 'Cust', flex: .5}] : []),
    { field: 'wo_date', headerName: 'Order Date', flex: 1, sortComparator: true },
    { field: 'cust_po', headerName: 'PO #', flex: 1, sortComparator: true },
    { field: 'cust_req', headerName: 'Req #', flex: 1, sortComparator: true },
    { field: 'ship_to', headerName: 'Ship To', flex: 3, sortComparator: true },
    { field: 'status', headerName: 'Status', flex: 1, sortComparator: true,
      renderCell: (params) => {
          const status = params.value;
          const color = status === 'COMPLETE' ? '#BABCBE' : status === 'OPEN' ? '#92D09E' : 'inherit';
          return (
          <span style={{ background: color, width: '100%', height: '100%', paddingLeft: '10px',alignContent: 'center' }}>
              {status}
          </span>
          );
      },
    },
    { field: 'work_order', headerName: 'Order #', flex: 1 },
    { field: 'invoice', headerName: 'Invoice', flex: .75, sortComparator: true },
    { field: 'ivh_date', headerName: 'Invoice Date', flex: 1 },
    { field: 'payment', headerName: 'Payment', flex: .75 },
    
  ];

  const mobileColumns = [
      { field: 'wo_date', headerName: 'Order Date', flex: 1, sortComparator: true },
      { field: 'cust_po', headerName: 'PO #', flex: 1, sortComparator: true },
      { field: 'cust_req', headerName: 'Req #', flex: 1, sortComparator: true },
      { field: 'ship_to', headerName: 'Ship To', flex: 3, sortComparator: true },
      { field: 'ship_via', headerName: 'Ship Via', flex: 1, sortComparator: true,},
      { field: 'status', headerName: 'Status', flex: 1, sortComparator: true,
        renderCell: (params) => {
            const status = params.value;
            const color = status === 'COMPLETE' ? 'grey' : status === 'OPEN' ? 'green' : 'inherit';
            return (
              <Typography sx={{ color: color }}>
                {status}
              </Typography>
            );
        },
      },
      { field: 'work_order', headerName: 'Order #', flex: 1 },
  ];

  return (
    <Box>
      <UniversalDataGrid
        source="workorder"
        endpoint="WorkOrdersList"
        downloadKey="WorkOrderDownload"
        columns={columns}
        mobileColumns={mobileColumns}
        searchLabel="Orders"
        customSortField="work_order"
        onRowClick={handleRowClick}
        tooltipFields={["wo_date", "cust_po", "cust_req", "ship_to", "invoice_date"]}
      />
      
      <WorkOrderModal
        open={!!selectedRow}
        onClose={handleCloseModal}
        rowData={selectedRow}
      />

    </Box>
  );
}
